<template>
  <canvas ref="financialSummaryChart"></canvas>
</template>

<script>
import Chart from "chart.js";

export default {
  props: {
    period: Array,
    incomeData: Array,
    expensesData: Array,
    sumData: Array,
  },

  mounted() {
    const ctx = this.$refs.financialSummaryChart;
    ctx.height = 100;

    const chartData = {
      type: "bar",
      data: {
        labels: this.period,
        datasets: [
          {
            label: "Ergebnis",
            type: "line",
            data: this.sumData,
            backgroundColor: "rgba(57, 84, 171,.3)",
            borderColor: "#3954AB",
            borderWidth: 3,
            order: 1,
          },
          {
            label: "Erlöse",
            type: "bar",
            data: this.incomeData,
            backgroundColor: "rgba(0, 191, 48,.5)",
            borderColor: "#00BF30",
            borderWidth: 3,
            order: 2,
          },
          {
            label: "Kosten",
            type: "bar",
            data: this.expensesData,
            backgroundColor: "rgba(255, 48, 48,.5)",
            borderColor: "#FF3030",
            borderWidth: 3,
            order: 3,
          },
        ],
      },
      options: {
        responsive: true,
        lineTension: 1,
        tooltips: {
            mode: 'index',
            callbacks: {
                label: function(t, d) {
                var xLabel = d.datasets[t.datasetIndex].label;
                var yLabel = t.yLabel.toFixed(2).toString().replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ".") + '€';
                return xLabel + ': ' + yLabel;
                }
            }
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                padding: 15,
                callback: function(value) {
                    return value.toString().replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ".") + '€';
                }
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: false,
                padding: 15,
                autoSkip: false,
              },
            },
          ],
        },
      },
    };

    new Chart(ctx, chartData);
  },
};
</script>

<style>
</style>
